import globals from '@descope-ui/theme-globals';
import { AutocompleteFieldClass } from './component/AutocompleteFieldClass';
import { getThemeRefs } from '@descope-ui/common/theme-helpers';
import { refs } from '@descope-ui/theme-input-wrapper';

const vars = AutocompleteFieldClass.cssVarList;
const globalRefs = getThemeRefs(globals);

const autocompleteField = {
  [vars.hostWidth]: refs.width,
  [vars.hostDirection]: refs.direction,
  [vars.fontSize]: refs.fontSize,
  [vars.checkmarkDisplay]: 'none',
  [vars.itemPaddingInlineStart]: globalRefs.spacing.lg,
  [vars.itemPaddingInlineEnd]: globalRefs.spacing.lg,
  [vars.selectedItemBackground]: globalRefs.colors.primary.light,
  [vars.selectedItemHoverBackground]: globalRefs.colors.primary.light,
  [vars.selectedItemFocusBackground]: globalRefs.colors.primary.light,
  [vars.itemHoverBackground]: globalRefs.colors.primary.highlight,

  _fullWidth: {
    [vars.hostWidth]: '100%',
  },
};

export default autocompleteField;
export { vars };
